import React from "react";
import { getSource, minicount } from "./utilities";
import ModalPrint from "../modals/modalPrint";
import { Button } from "../components/inputs";

function ViewNavbar(props) {
  const title = getSource(props, ["title"], "");
  const state = getSource(props.data, ["state"], "0");
  const all = getSource(props.data, ["all"], 0);
  const end = getSource(props.data, ["end"], 0);
  const search = getSource(props.data, ["search"], "");
  const handleChange = (e) => {
    props.onChange(e);
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      props.onSearch();
    }
  };

  return (
    <React.Fragment>
      <nav className="navbar navbar-light bg-light view-navbar">
        <div className="navbar-brand view-title">
          {title}
          {state === "1" ? ` - Terminados` : state === "2" ? ` - Cancelados` : ""}
          {all > 0 ? ` (${minicount(end)} de ${minicount(all)})` : ""}
        </div>
        <div className="form-inline">
          <div className="input-group input-group-sm view-search">
            <input
              type="text"
              className="form-control"
              autoComplete="nope"
              placeholder="Buscar"
              name="search"
              value={search}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
            />
            <div className="input-group-append">
              <Button className="btn btn-secondary" onClick={props.onSearch}>
                <i className="fa fa-search"></i>
              </Button>
              <button
                className="btn btn-secondary dropdown-toggle"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="fa fa-bars"></i>
              </button>
              <div className="dropdown-menu">
                {props.states.map((item, i) => {
                  return (
                    <div
                      key={i}
                      className={state === item._state ? "dropdown-item active" : "dropdown-item"}
                      onClick={() => props.onState(item._state)}
                    >
                      {item.caption}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <ModalPrint className="btn btn-secondary btn-sm ml-2" params={props.printParams}>
            <i className="fa fa-print"></i>
          </ModalPrint>
          <props.Modal className="btn btn-primary btn-sm ml-2" isNew={true} onChange={props.onChange}>
            Nuevo
          </props.Modal>
        </div>
      </nav>
    </React.Fragment>
  );
}

export default ViewNavbar;
